import uniq from 'lodash/uniq';

function formatTailleMateriel(materiel) {
  const longueur = materiel?.materielTechnique?.longueur;
  const hauteur = materiel?.materielTechnique?.largeur;

  if (longueur == null && hauteur == null) return '';

  const dimensions = [];
  if (longueur != null) dimensions.push(`L${longueur}`);
  if (hauteur != null) dimensions.push(`H${hauteur}`);

  return dimensions.join(' X ');
}
export function formatTaillesMateriels(materiels) {
  if (!Array.isArray(materiels) || !materiels?.length) return '';
  return uniq(materiels.map(formatTailleMateriel).filter(Boolean)).join(', ');
}
export function getTypeMaterielLibelle(materiels, materielType) {
  const result = (materiels || []).filter(m => m.typeId).map(m => {
    const type = materielType.find(t => t.id === m.typeId);
    let materielLibelle = type.libelle;

    const dimension = formatTailleMateriel(m);
    if (dimension !== '') {
      materielLibelle += ` (${dimension})`;
    }

    return materielLibelle;
  });
  return uniq(result).join(', ');
}
